import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compare } from '../utils/categories';
import { useSelector } from 'react-redux';
//
// Разбирает список категорий на основные и дополнительные/специальные.
// Основные категории разбираем по папкам.
// Все списки сортируем.
//
const useCategories = ({ lang }) => {
    const [ addon, setAddon ] = useState([]);
    const [ admin, setAdmin ] = useState([]);
    const [ folders, setFolders ] = useState([]); // основные категории разобранные по папкам
    const [ orphans, setOrphans ] = useState([]); // основные категории без папок
    const categories = useSelector(state => state.categories);

	useEffect(() => {

		//if(!categories) return;

        const main  = [];
        const addon = [];
        const admin = [];

        categories.forEach(item => {
            switch(item.type) {
                case 'admin':
                    admin.push(item);
                    break;
                case 'addon':
                    addon.push(item);
                    break;
                default:
                    main.push(item);
                    break;
            }
        });

        addon.sort((a, b) => compare(a, b, lang));
        admin.sort((a, b) => compare(a, b, lang));
        setAddon(addon);
        setAdmin(admin);

        const folders = [];
        const orphans = [];

        main.forEach(cat => {
            if(cat.is_folder) folders.push({ ...cat, categories: [] });
            else if(!cat.folder) orphans.push(cat);
        });

        main.forEach(cat => {
            if(cat.is_folder || !cat.folder) return;
            const folder = folders.find(f => f._id === cat.folder);
            if(!folder) return;
            folder.categories.push(cat);
        });

        folders.sort((a, b) => compare(a, b, lang));
        orphans.sort((a, b) => compare(a, b, lang));

        folders.forEach(f => f.categories.sort((a, b) => compare(a, b, lang)));

        setFolders(folders);
        setOrphans(orphans);

	}, [ categories, lang ]);

	return [ folders, orphans, addon, admin ];
};

useCategories.propTypes = {
    categories: PropTypes.array.isRequired,
    lang: PropTypes.oneOf(['ru','en']),
};

useCategories.defaultProps = {
	categories: [],
    lang: 'ru',
};

export default useCategories;
